/**
 * Translation keys of the Terms of Use dialog (scope Shell of the translation service) and the texts used
 * until these keys are maintained there: the Legacy translations (`TermsOfUse.TermsOfUse_Check_Accept`,
 * `TermsOfUse.TermsOfUse_Button_Accept`), so the dialog reads the same as in Legacy.
 */
export const TermsOfUseKeys = {
  checkAccept: 'Shell.TermsOfUse.CheckAccept',
  buttonAccept: 'Shell.TermsOfUse.ButtonAccept'
} as const;

type TermsOfUseText = keyof typeof TermsOfUseKeys;

const ENGLISH_CHECK = 'I accept the terms of use';

const FALLBACK_TEXTS: Readonly<Record<string, Readonly<Record<TermsOfUseText, string>>>> = {
  bg: { checkAccept: 'Приемам тези условия за ползване', buttonAccept: 'Приемане' },
  cs: { checkAccept: 'Přijímám tyto podmínky použití', buttonAccept: 'Přijmout' },
  de: { checkAccept: 'Ich akzeptiere diese Nutzungsbedingungen', buttonAccept: 'Akzeptieren' },
  el: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Αποδοχή' },
  en: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Accept' },
  es: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Aceptar' },
  fr: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Accepter' },
  hr: { checkAccept: 'Prihvaćam ove uvjete korištenja', buttonAccept: 'Prihvatiti' },
  hu: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Elfogadás' },
  it: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Accetta' },
  ja: { checkAccept: '利用規約に同意します', buttonAccept: '同意' },
  ko: { checkAccept: '약관을 수락합니다', buttonAccept: '수락' },
  nb: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Godta' },
  nl: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Accepteren' },
  pl: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Akceptuj' },
  'pt-BR': { checkAccept: 'Eu aceito essas condições de uso', buttonAccept: 'Aceitar' },
  pt: { checkAccept: 'Aceito estas condições de utilização', buttonAccept: 'Aceitar' },
  ro: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Acceptare' },
  ru: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Принять' },
  se: { checkAccept: 'Jag accepterar dessa användningsvillkor', buttonAccept: 'Acceptera' },
  sk: { checkAccept: 'Prihvatam uslove korišćenja', buttonAccept: 'Prihvati' },
  th: { checkAccept: 'ฉันยอมรับข้อตกลงในการใช้งาน', buttonAccept: 'ยอมรับ' },
  tr: { checkAccept: ENGLISH_CHECK, buttonAccept: 'Kabul et' },
  vi: { checkAccept: 'Đồng ý điều khoản sử dụng', buttonAccept: 'Đồng ý' },
  zh: { checkAccept: '我接受使用条款', buttonAccept: '接受' }
};

/** Text for a language without a maintained translation; English when the language is unknown. */
export function termsOfUseFallback(text: TermsOfUseText, language: string | undefined): string {
  return (language && FALLBACK_TEXTS[language]?.[text]) || FALLBACK_TEXTS['en'][text];
}
